(function(){
	'strict';

	Vue.component('select-tests', {
		props: ['value', 'placeholder'],
		data() {
			return {
				filterText: '',
				open: false,
				filterIndex: 0,
				selectedIndex: 0,
				loadingTests: false
			};
		},
		methods: {
			remove(test) {
				this.loadingTests = false;
				const id = test.resultId ? test.resultId : test.id;
				const fieldName = test.resultId ? "resultId" : "id";
				const index = this.value.findIndex(t => t[fieldName] == id);
				if (index >= 0) {
					this.value.splice(index, 1);
					this.$emit('remove-test', id);
				}
			},
			toggle(id, event) {
				this.loadingTests = true;
				this.$emit('add-test', id);
				this.open = true;
			},
			has(id) { return !!this.value.find(t => t.id == id) },
			inputEnter() {
				if ( this.open && this.filterIndex >= 0 ) {
					const t = this.filteredTests[this.filterIndex];
					if (t) {
						this.toggle(t.id);
						this.filterText = '';//t.testName;
						this.filterIndex = 0;
					}
				}
				this.open = true;
			},
			inputUp() {
				if (this.open) {
					if (this.filterIndex >= 0) {
						if ( --this.filterIndex >= 0 )
							this.$refs.filtered[this.filterIndex].firstChild.focus();
						this.$refs.input.focus();
					}
				}
				this.open = true;
			},
			inputDown () {
				if (this.open) {
					if (this.filterIndex < this.filteredTests.length - 1) {
						this.$refs.filtered[++this.filterIndex].firstChild.focus();
						this.$refs.input.focus();
					}
				}
				this.open = true;
			},
			inputEsc() {
				if (this.open) {
					this.open = false;
				} else {
					this.filterText = '';
					this.filterIndex = 0;
				}
			},
			selectUp() {
				if (this.selectedIndex > 0) {
					this.$refs.selected[--this.selectedIndex].firstChild.focus();
				}
			},
			selectDown () {
				if (this.selectedIndex < this.value.length - 1) {
					this.$refs.selected[++this.selectedIndex].firstChild.focus();
				}
			},
			selectFocused(index) {
				if (this.selectedIndex != index);
					this.selectedIndex = index;
			},
			delayBlur() {
				setTimeout(() => {
					this.open = false;
				}, 3500); //modify this value if you want the dropdown to stay open longer.
			}
		},
        computed: {
			_testList() {
				this.loadingTests = false;
				return store.state.testList;
			},
			filteredTests() {
				if ( ! this.filterText )
					return this._testList;
				const ucFilter = this.filterText.toUpperCase();
				return this._testList
					.filter(t => t.testName.toUpperCase().indexOf(ucFilter) === 0);
			}
		},
		watch: {
			_testList(newTests, oldTests) {
				this.$emit('input', this.value);
			},
			filteredText(value, oldValue) {
				const ucOldFilter = oldValue.toUpperCase();
				const oldFiltered = this._testList
					.filter(t => t.testName.toUpperCase().indexOf(ucOldFilter) === 0);
				const id = oldFiltered[this.filterIndex] ? oldFiltered[this.filterIndex].id : undefined;
				const ucFilter = value.toUpperCase();
				this.filterIndex = this._testList
					.filter(t => t.testName.toUpperCase().indexOf(ucFilter) === 0)
					.findIndex(t => t.id == id);
			}
		},
		template:
			`<div class="select-tests">
				<ul v-show="value.length" class="tests mb-1">
					<li v-for="(test,index) in value" ref="selected">
						<button title="Remove Test" class="btn-ty"
							@click="remove(test)"
							@keydown.down="selectDown"
							@keydown.up="selectUp"
							@focus="selectFocused(index)"
							:tabindex="index == selectedIndex ? 0 : -1"><i class="fas fa-trash-alt"></i></button>
						{{test.testName}}
					</li>
				</ul>
				<div class="with-dropdown">
					<div class="search">
						<div class="controls">
							<span :class="'fas fa-times' + (filterText ? '' : ' invisible')" @click="filterText = ''"
							></span><span :class="'fas fa-angle-' + (open ? 'up' : 'down')"></span>
						</div>
						<div class="input-wrapper">
							<input ref="input" type="text" class="" v-model="filterText" :placeholder="placeholder"
								@input="open=true"
								@keydown.enter="inputEnter"
								@keydown.down="inputDown"
								@keydown.up="inputUp"
								@keydown.esc="inputEsc" 
								@blur="delayBlur()"/>
						</div>
					</div>
					<ul v-show="open" class="filteredTests">
						<li v-for="(test, index) in filteredTests" ref="filtered" :class="{'active': index == filterIndex}"
							:title="'Add Test'"
							class="btn-ty">
							<a href="#" 
							@mousedown="toggle(test.id,$event)">
								<i :class="'fas fa-plus'"></i>
								{{test.testName}}
							</a>
						</li>
					</ul>
				</div>
			</div>`
	});
})();
